module.exports = __webpack_public_path__ + "static/media/image.0291c467.png";